import moment from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

moment.extend(weekOfYear);
const init = Vue => {
  /**
   * 日期格式化插件
   * @type {moment | ((inp?: moment.MomentInput, format?: moment.MomentFormatSpecification, language?: string, strict?: boolean) => moment.Moment) | ((inp?: moment.MomentInput, format?: moment.MomentFormatSpecification, strict?: boolean) => moment.Moment)}
   */
  Vue.prototype.$moment = moment;

  /**
   * 格式化日期
   * @param date
   * @returns {string}
   */
  Vue.prototype.$formatDate = function (date) {
    let number = Number(date);
    date = Number.isNaN(number) ? date : number;
    return date ? moment(date).format('YYYY-MM-DD') : '';
  };
  /**
   * 格式化时间
   * @param time
   * @returns {string}
   */
  Vue.prototype.$formatTime = function (time) {
    let number = Number(time);
    time = Number.isNaN(number) ? time : number;
    return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '';
  };

  Vue.prototype.$formatMinute = function (time) {
    let number = Number(time);
    time = Number.isNaN(number) ? time : number;
    return time ? moment(time).format('YYYY-MM-DD HH:mm') : '';
  };

  /**
   * @param type 0图标, 1文字, 2图标加文字
   * @param title 文字
   * @param icon 图标
   * @param handler 点击处理函数
   * @returns {{type: *, title: (*|string), icon: (*|string), handler: *}}
   */
  Vue.prototype.$createRightNavObject = function (type, title = '', icon = '', handler = () => {
  }) {
    return {
      type: type,
      title: title,
      icon: icon,
      handler: handler
    };
  };

  Vue.prototype.$navigateTo = function (path, query) {
    this.$router.push({path, query});
  };

  Vue.prototype.$setNavigateTitle = function (title) {
    this.$store.commit('initNavTitle', title);
  };

  Vue.prototype.$initRightNavBar = function (navBar) {
    this.$store.commit('initRightNavBar', Array.isArray(navBar) ? navBar : [navBar]);
  };
  Vue.prototype.$initLeftNavBar = function (navBar) {
    this.$store.commit('initLeftNavBar', Array.isArray(navBar) ? navBar : [navBar]);
  };

  Vue.prototype.$showLoading = function () {
    this.$store.commit('initLoading', true);
  };

  Vue.prototype.$hideLoading = function () {
    this.$store.commit('initLoading', false);
  };

  //获取节次
  Vue.prototype.$getSectionList = function (start, end) {
    let sectionList = [];
    for (let i = parseInt(start, 10); i <= end; i++) {
      sectionList.push(i);
    }
    return sectionList;
  };

  Vue.filter('formatClazzName', function (value) {
    if (!value) return '';
    return value.length > 7 ? value.substring(0, 7) + '...' : '';
  });

  // 通用请求方法
  Vue.prototype.$tnAjax = function (httpPromise, option = {
    successTitle: '',
    errorTitle: '',
    success: () => {
    },
    error: () => {
    }
  }) {
    const {successTitle, errorTitle, success, error} = option;
    httpPromise.then(res => {
      successTitle && this.$toast.success({
        duration: 2000,
        message: successTitle
      });
      success && success.call(this, res);
    }).catch(e => {
      this.$toast.fail({
        duration: 2000,
        message: e.response && e.response.data && e.response.data.msg || errorTitle || '操作失败'
      });
      error && error.call(this, e);
    });
  };

  Vue.prototype.$downloadFile = function (src, fileName) {
    let $a = document.createElement('a');
    $a.setAttribute('href', src);
    $a.setAttribute('download', fileName);
    let fileLink = document.createElement('span');
    fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent');
    $a.appendChild(fileLink);
    let body = document.getElementsByTagName('body')[0];
    body.appendChild($a);
    fileLink.click();
    // body.removeChild($a);
  };

  Vue.prototype.$isWechat = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    console.log(ua);
    console.log(ua.match(/MicroMessenger/i));
    if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_') {
      return true;
    } else {
      return false;
    }
  };
};

export default init;
